'use strict';

/**
 *
 * @name: nownessApp.genericDirectives
 *
 */

import HeartRateDirective from './nn-heart-rate/nn-heart-rate.directive';
import NnSocialIconsHeaderDirective from './nn-social-icons-header/nn-social-icons-header.directive';
import DeprecatedSortDropdownDirective from './DEPRECATED-nn-sort-dropdown/nn-sort-dropdown.directive';
import SpinnerDirective from './nn-spinner/nn-spinner.directive';
import NnSocialListDirective from './nn-social-list/nn-social-list.directive';
import NnNotificationsListDirective from './nn-notifications-list/nn-notifications-list.directive'
import NnGeneralSidenavDirective from './nn-general-sidenav/nn-general-sidenav.directive';
import NnRollOutSectionDirective from './nn-roll-out-section/nn-roll-out-section.directive';

import NnHeaderMainDirective from './nn-header-main/nn-header-main.directive';
import NnFooterMainDirective from './nn-footer-main/nn-footer-main.directive';


import EqualizeHeightDirective from './nn-equalize-height.directive';
import HorizontalScrollDirective from './nn-horizontal-scroll.directive';
import NgDelayDirective from './ng-delay.directive';
import NgFocusDirective from './ng-focus.directive';
import NnCollapseDirective from './nn-collapse.directive';
import NnCustomCssInjectorDirective from './nn-custom-css-injector.directive';
import NnInfoBarDirective from './nn-info-bar.directive';
import NnSelectboxDirective from './nn-selectbox.directive';
import PlayButtonDirective from './nn-play-button.directive';
import ReadMoreDirective from './nn-read-more.directive';
import RemindMeDirective from './nn-remind-me.directive';
import NnTrackingPixelDirective from './nn-tracking-pixel.directive';
import NnNgRepeatFinishedDirective from './nn-ng-repeat-finished.directive';
import NnLazyImgDirective from './nn-lazy-img.directive';
import NnLazyBackgroundDirective from './nn-lazy-background.directive';

const GenericDirectivesModule = angular
  .module('nownessApp.genericDirectives', [])
  .directive('equalizeHeight', EqualizeHeightDirective)
  .directive('heartRate', HeartRateDirective)
  .directive('horizontalScroll', HorizontalScrollDirective)
  .directive('ngDelay', NgDelayDirective)
  .directive('ngFocus', NgFocusDirective)
  .directive('nnCustomCssInjector', NnCustomCssInjectorDirective)
  .directive('nnCollapse', NnCollapseDirective)
  .directive('nnInfoBar', NnInfoBarDirective)
  .directive('nnSelectbox', NnSelectboxDirective)
  .directive('nnHeaderMain', NnHeaderMainDirective)
  .directive('nnFooterMain', NnFooterMainDirective)
  .directive('nnSocialIconsHeader', NnSocialIconsHeaderDirective)
  .directive('playButton', PlayButtonDirective)
  .directive('readMore', ReadMoreDirective)
  .directive('remindMe', RemindMeDirective)
  .directive('nnTrackingPixel', NnTrackingPixelDirective)
  .directive('sortDropdown', DeprecatedSortDropdownDirective) // TODO: finally remove
  .directive('spinner', SpinnerDirective)
  .directive('nnSocialList', NnSocialListDirective)
  .directive('nnNotificationsList', NnNotificationsListDirective)
  .directive('nnGeneralSidenav', NnGeneralSidenavDirective)
  .directive('nnRollOutSection', NnRollOutSectionDirective)
  .directive('endRepeat', NnNgRepeatFinishedDirective)
  .directive('lazyImg', NnLazyImgDirective)
  .directive('lazyBackground', NnLazyBackgroundDirective)

export default GenericDirectivesModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-generic-directives.module.js